if (process.client) {
    window.swiper = require('swiper')
}